import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const BidIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
    <path
      d="M12 6.44378C12 9.4503 9.53757 11.8876 6.5 11.8876C3.46243 11.8876 1 9.4503 1 6.44378C1 3.43726 3.46243 1 6.5 1V1.72584V2.45168V6.44378"
      stroke="currentColor"
    />
    <path
      d="M11.9998 6.44629C11.9998 6.20439 11.9839 5.96618 11.953 5.73263M11.4414 4.05335C11.5324 4.23717 11.6133 4.4268 11.6832 4.62155M8.61894 1.42126C8.47949 1.36358 8.33713 1.31142 8.19214 1.26506M9.46137 1.85828C9.60724 1.95072 9.74841 2.04978 9.88445 2.15505M10.9811 3.28933C10.8735 3.14002 10.7585 2.99631 10.6366 2.85874"
      stroke="currentColor"
    />
  </svg>,
  'bid'
);
